<script setup lang="ts">
defineProps<{ isMenuOpen: boolean }>()

const emit = defineEmits(['toggleMenu'])

const { links: headerNavbarLinks } = useHeaderNavbarItems()
const gtm = useGTM()

const mainCategories = computed(() => headerNavbarLinks.value?.slice(0, 3) ?? [])

const { isAddressOrPaymentStep } = useLogoLink()

function onMenuClick(menuItemLink: string) {
  gtm.pushMenuClick({
    menuItemLink,
    navigationType: 'mobile',
    menuType: 'main',
  })
}

function toggleMenu() {
  emit('toggleMenu')
}
</script>

<template>
  <div
    class="mobile-nav"
    :class="{ 'mobile-nav--logo-only': isAddressOrPaymentStep }"
  >
    <div class="mobile-nav__left">
      <span class="mobile-nav__logo">
        <HeaderLogo
          :is-logo-collapsed="true"
          @toggle-menu="toggleMenu"
        />
      </span>
      <span
        v-if="!isAddressOrPaymentStep"
        class="mobile-nav__menu-icon"
      >
        <button
          :class="[{ open: !isMenuOpen, close: isMenuOpen }]"
          data-test="menu-icon"
          :aria-label="$t('openMenu')"
          @click.prevent="toggleMenu"
        />
      </span>
    </div>
    <div
      v-if="!isAddressOrPaymentStep"
      class="mobile-nav__categories"
    >
      <NuxtLink
        v-for="link in mainCategories"
        :key="link._uid"
        :target="link.url.startsWith('http') ? '_blank' : '_self'"
        :to="$url(link.url)"
        class="mobile-nav__category-link"
        @click="onMenuClick($url(link.url))"
      >
        {{ link.text }}
      </NuxtLink>
    </div>
    <HeaderCartLink
      v-if="!isAddressOrPaymentStep"
      data-accessibility="cart"
    />
  </div>
</template>

<style lang="scss" scoped>
.mobile-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  &--logo-only {
    justify-content: center;
  }

  &__logo {
    width: 4.8rem;
    height: 4.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__menu-icon {
    width: 3.0rem;
    height: 3.0rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__left {
    display: flex;
    align-items: center;
  }

  &__categories {
    flex-grow: 1;
    display: flex;
    justify-content: space-evenly;
  }

  &__category-link {
    font-size: 1.4rem;
    font-weight: 500;
    color: var(--black);
    text-decoration: none;
  }
}

.open {
  width: 2.4rem;
  height: 2.4rem;
  background-color: var(--black);
  mask: url('/icons/menu.svg') no-repeat center / contain;
}

.close {
  width: 2.4rem;
  height: 1.2rem;
  background-color: var(--black);
  mask: url('/icons/close.svg') no-repeat center / contain;
}
</style>
